import { useNosIdMutation } from '@/hooks/api/base.hooks';
import { api } from '@/portal-api.definition';
import { ActionType } from '@nosinovacao/nosid-mfe-common';

export function useSetupMfa() {
  return useNosIdMutation({
    mutationFn: () => api.post('/api/v1/mfa/setup', void 0),
    successLogAction: () => ({
      ActionType: ActionType.EnableTwoFactorAuth,
      Option: 'AuthenticatorApp',
    }),
    errorLogAction: () => ({
      ActionType: ActionType.EnableTwoFactorAuth,
      Option: 'AuthenticatorApp',
    }),
  });
}
